// @flow
export const createAPIEndpoints = ({ JSON }: Object): Object => ({
	fetch: () => JSON.get('venues.json'),
});

export default createAPIEndpoints;


// WEBPACK FOOTER //
// ./src/utils/api/venues/index.js